import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
  error:{}
}

export const DeletePartcipantSlice = createSlice({
  name: 'PartcipantSlice',
  initialState,
  reducers: {
    Admin_Delete_Partcipant_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Admin_Delete_Partcipant_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Admin_Delete_Partcipant_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Admin_Delete_Partcipant_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Clear_Admin_Delete_Partcipant_Check, Admin_Delete_Partcipant_failure, Admin_Delete_Partcipant_success, Admin_Delete_Partcipant_request } = DeletePartcipantSlice.actions

export default DeletePartcipantSlice.reducer